/**
 * @typedef {import('../types').AllocationTargetType} AllocationTargetType
 * @typedef {import('../types').AllocationMode} AllocationMode
 * @typedef {import('../types').AllocationHoldState} AllocationHoldState
 */

/**
 * @typedef {Object} AllocationHold
 * @property {string} holdId
 * @property {string} competitionId
 * @property {string} matchId
 * @property {AllocationTargetType} targetType
 * @property {string} targetId
 * @property {AllocationMode} mode
 * @property {AllocationHoldState} state
 * @property {number} allocationEpoch
 * @property {number} heldAtMs
 * @property {number | null} releasedAtMs
 */

/**
 * @param {string} competitionId
 * @param {AllocationTargetType} targetType
 * @param {string} targetId
 */
export function buildHoldDocId(competitionId, targetType, targetId) {
  const prefix = targetType === "participant" ? "participant" : "resource";
  return `${prefix}_${targetId}`;
}
